import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, roles }) {
    const { user } = useAuth();
    const loc = useLocation();
    if (user === null) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-ink-300">
                <div className="text-silver-400 font-display text-2xl silver-text">
                    Loading vault…
                </div>
            </div>
        );
    }
    if (!user) {
        return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname)}`} replace />;
    }
    if (roles && !roles.includes(user.role)) {
        return <Navigate to="/dashboard" replace />;
    }
    return children;
}
